import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/grupo-de-acesso',
		component: Base,
		children: [
			{
				path: '',
				name: 'GrupoDeAcessoList',
				component: List,
				meta: {
					path: '/admin/grupo-de-acesso',
					pai: 'Admin',
					title: 'siS - Grupo de Acesso',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Grupo de Acesso',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'GrupoDeAcessoNovo',
				component: Form,
				meta: {
					path: '/admin/grupo-de-acesso',
					pai: 'Admin',
					title: 'siS - Grupo de Acesso - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Grupo de Acesso',
						class: '',
						active: false,
						url: '/admin/grupo-de-acesso'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'GrupoDeAcessoEditar',
				component: Form,
				meta: {
					path: '/admin/grupo-de-acesso',
					pai: 'Admin',
					title: 'siS - Grupo de Acesso - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Grupo de Acesso',
						class: '',
						active: false,
						url: '/admin/grupo-de-acesso'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]